module.exports = __webpack_public_path__ + "static/media/city.8f7f88c0.svg";